import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Text, InputTextArea, InputLabel } from '@brokerbay/elements-web';
import { ConfirmationInstructions } from '@bb/domain/dist/types/AppointmentConfig';
import { AuthContext } from 'contexts';
import { AccessOptionProps } from '../../types';
import SupraLockValidator from '../../../AccessValidators/SupraLockValidator';
import UploadEditPhotoButton from '../UploadEditPhotoButton';

const SupraMVP: React.FC<AccessOptionProps> = ({
  listing,
  showingsConfig,
  setShowingsConfig,
  setIsValid,
}) => {
  const { auth } = useContext(AuthContext);

  const [isSupraLockCodeValid, setIsSupraLockCodeValid] = useState(true);
  const [shouldGetLockboxes, setGetLockboxesFalse] = useReducer(
    () => false,
    true,
  );
  const setSupraLockInfo = (
    info: Partial<ConfirmationInstructions['supralockbox']>,
  ) => {
    setShowingsConfig(prev => ({
      ...prev,
      instructions: {
        ...prev.instructions,
        supralockbox: {
          ...(prev.instructions.supralockbox || {}),
          ...info,
        } as any,
      },
    }));
  };

  useEffect(() => {
    setIsValid(isSupraLockCodeValid);
  }, [setIsValid, showingsConfig, isSupraLockCodeValid]);

  return (
    <>
      <div>
        <InputLabel label="Select Lockbox" required />
        <SupraLockValidator
          setGetLockboxesFalse={setGetLockboxesFalse}
          shouldGetLockboxes={shouldGetLockboxes}
          listingId={listing.id.toString()}
          listingReps={listing.reps}
          setIsSupraLockCodeValid={setIsSupraLockCodeValid}
          supraLockInfo={showingsConfig.instructions.supralockbox}
          setSupraLockInfo={setSupraLockInfo}
          supraSubscriptionStatus={auth.supraSubscription?.status}
        />
      </div>
      <UploadEditPhotoButton
        listingId={listing.id}
        lockboxPhoto={showingsConfig.lockboxPhoto}
        setLockboxPhoto={val => {
          setShowingsConfig(prev => ({
            ...prev,
            lockboxPhoto: val,
          }));
        }}
      />
      <div>
        <InputTextArea
          label="Special access instructions"
          labelExtra="(optional)"
          dataCy="showing-notification-supra-lockbox-instructions"
          value={showingsConfig.instructions.supralockbox?.details || ''}
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                supralockbox: {
                  ...(prev.instructions.supralockbox || {}),
                  details: value,
                },
              } as any,
            }))
          }
        />
      </div>
    </>
  );
};

export default SupraMVP;
